import { styled } from '@mui/material'
import MuiTooltip from '@mui/material/Tooltip'
import { TooltipProps } from './Tooltip.types'

export const Tooltip = styled(({ className, children, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }}>
    {children}
  </MuiTooltip>
))`
  .MuiTooltip-tooltip {
    margin-top: 4px;
    padding: 8px 12px;
    background-color: ${({ theme }) => theme.palette.primary.refer![400]};
    color: ${({ theme }) => theme.palette.common.white};
    border-radius: 4px;
  }

  ul {
    margin: 0 0 0 12px;
    padding: 0;
  }

  .MuiTooltip-arrow {
    color: ${({ theme }) => theme.palette.primary.refer![400]};
  }
`
